<mat-sidenav-container fullscreen>
  <mat-sidenav
    #sidenav
    mode="side"
    [opened]="isAuthenticated()"
    class="w-64 border-r border-[var(--mat-sys-outline-variant)] bg-[var(--mat-sys-surface)] flex flex-col overflow-hidden"
  >
    <mat-toolbar
      class="!bg-[var(--mat-sys-surface)] border-b border-[var(--mat-sys-outline-variant)] flex-none"
    >
      <a
        routerLink="/"
        class="flex items-center gap-3 no-underline text-inherit hover:no-underline px-2"
      >
        <img src="/icon.svg" alt="AppsLogic" class="w-10 h-10 object-contain" />
        <span class="font-mono font-extrabold text-2xl text-[var(--mat-sys-on-surface)]"
          >AppsLogic</span
        >
      </a>
    </mat-toolbar>

    <nav class="flex-1 overflow-y-auto pt-2 pb-4">
      <!-- Dashboard (always visible, no accordion) -->
      <mat-nav-list class="!py-0 !px-2">
        <a
          mat-list-item
          routerLink="/home"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
          class="mb-1 rounded-lg"
        >
          <mat-icon matListItemIcon class="!text-[var(--mat-sys-on-surface-variant)]"
            >dashboard</mat-icon
          >
          Dashboard
        </a>
      </mat-nav-list>

      <!-- Accordion navigation groups -->
      <mat-accordion class="nav-accordion" multi>
        <!-- ── Bookkeeping ─────────────────────────── -->
        <mat-expansion-panel
          [expanded]="isGroupExpanded('bookkeeping')"
          (expandedChange)="onGroupExpanded('bookkeeping', $event)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title class="flex items-center gap-2">
              <mat-icon class="nav-group-icon">edit_note</mat-icon>
              Bookkeeping
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list class="!py-0 !px-2">
            <a
              mat-list-item
              routerLink="/transactions"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon
                matListItemIcon
                [matBadge]="pendingLinksCount() > 0 ? pendingLinksCount() : null"
                matBadgeColor="warn"
                matBadgeSize="small"
                >receipt_long</mat-icon
              >
              <span matListItemTitle>Transactions</span>
            </a>
            <a
              mat-list-item
              routerLink="/invoices"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>receipt</mat-icon>
              <span matListItemTitle>Invoices</span>
              <!-- Secondary router link so RouterLinkActive also matches /recurring-invoices* -->
              <span
                routerLink="/recurring-invoices"
                class="hidden"
                aria-hidden="true"
                tabindex="-1"
              ></span>
            </a>
            <a
              mat-list-item
              routerLink="/documents"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>description</mat-icon>
              <span matListItemTitle>Documents</span>
            </a>
            <a
              mat-list-item
              routerLink="/journal"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>book</mat-icon>
              <span matListItemTitle>Journal</span>
            </a>
            <a
              mat-list-item
              routerLink="/contacts"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>contacts</mat-icon>
              <span matListItemTitle>Contacts</span>
            </a>
            <a
              mat-list-item
              routerLink="/mandates"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>autorenew</mat-icon>
              <span matListItemTitle>Direct Debits</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- ── Analytics ──────────────────────────── -->
        <mat-expansion-panel
          [expanded]="isGroupExpanded('analytics')"
          (expandedChange)="onGroupExpanded('analytics', $event)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title class="flex items-center gap-2">
              <mat-icon class="nav-group-icon">bar_chart</mat-icon>
              Analytics
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list class="!py-0 !px-2">
            <a
              mat-list-item
              routerLink="/analysis"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>table_chart</mat-icon>
              <span matListItemTitle>Analysis</span>
            </a>
            <a
              mat-list-item
              routerLink="/reports"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>assessment</mat-icon>
              <span matListItemTitle>Reports</span>
            </a>
            <a
              mat-list-item
              routerLink="/ledger"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>account_balance_wallet</mat-icon>
              <span matListItemTitle>Ledger</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- ── Banking ────────────────────────────── -->
        <mat-expansion-panel
          [expanded]="isGroupExpanded('banking')"
          (expandedChange)="onGroupExpanded('banking', $event)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title class="flex items-center gap-2">
              <mat-icon class="nav-group-icon">account_balance</mat-icon>
              Banking
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list class="!py-0 !px-2">
            <a
              mat-list-item
              routerLink="/accounts"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>account_balance</mat-icon>
              <span matListItemTitle>Accounts</span>
            </a>
            <a
              mat-list-item
              routerLink="/institutes"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>corporate_fare</mat-icon>
              <span matListItemTitle>Institutes</span>
            </a>
            <a
              mat-list-item
              routerLink="/balances"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>savings</mat-icon>
              <span matListItemTitle>Balance Snapshots</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- ── Fixed Assets ──────────────────────── -->
        <mat-expansion-panel
          [expanded]="isGroupExpanded('fixed-assets')"
          (expandedChange)="onGroupExpanded('fixed-assets', $event)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title class="flex items-center gap-2">
              <mat-icon class="nav-group-icon">inventory_2</mat-icon>
              Assets &amp; Loans
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list class="!py-0 !px-2">
            <a
              mat-list-item
              routerLink="/assets"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>inventory_2</mat-icon>
              <span matListItemTitle>Fixed Assets</span>
            </a>
            <a
              mat-list-item
              routerLink="/loans"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>money_off</mat-icon>
              <span matListItemTitle>Loans</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- ── Automation ─────────────────────────── -->
        <mat-expansion-panel
          [expanded]="isGroupExpanded('automation')"
          (expandedChange)="onGroupExpanded('automation', $event)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title class="flex items-center gap-2">
              <mat-icon class="nav-group-icon">auto_awesome</mat-icon>
              Automation
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list class="!py-0 !px-2">
            <a
              mat-list-item
              routerLink="/categories"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>category</mat-icon>
              <span matListItemTitle>Categories</span>
            </a>
            <a
              mat-list-item
              routerLink="/rules"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>rule</mat-icon>
              <span matListItemTitle>Rules</span>
            </a>
            <a
              mat-list-item
              routerLink="/patterns"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>repeat</mat-icon>
              <span matListItemTitle>Patterns</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- ── Administration ─────────────────────── -->
        <mat-expansion-panel
          [expanded]="isGroupExpanded('administration')"
          (expandedChange)="onGroupExpanded('administration', $event)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title class="flex items-center gap-2">
              <mat-icon class="nav-group-icon">admin_panel_settings</mat-icon>
              Administration
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list class="!py-0 !px-2">
            <a
              mat-list-item
              routerLink="/entities"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>business</mat-icon>
              <span matListItemTitle>Entities</span>
            </a>
            <a
              mat-list-item
              routerLink="/email-ingestion"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>alternate_email</mat-icon>
              <span matListItemTitle>Email Ingestion</span>
            </a>
            <a
              mat-list-item
              routerLink="/admin/statement-templates"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>data_object</mat-icon>
              <span matListItemTitle>Statement Templates</span>
            </a>
            <a
              mat-list-item
              routerLink="/style-guide"
              routerLinkActive="!bg-[var(--mat-sys-primary-container)] !text-[var(--mat-sys-on-primary-container)]"
              class="mb-1 rounded-lg"
            >
              <mat-icon matListItemIcon>palette</mat-icon>
              <span matListItemTitle>Style Guide</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
      </mat-accordion>
    </nav>
  </mat-sidenav>

  <mat-sidenav-content class="bg-[var(--mat-sys-background)] flex flex-col h-full">
    @if (isAuthenticated()) {
      <mat-toolbar
        class="sticky top-0 z-[100] bg-[var(--mat-sys-surface)] border-b border-[var(--mat-sys-outline-variant)] px-6 flex-none text-[var(--mat-sys-on-surface)] shadow-sm"
      >
        <button mat-icon-button (click)="sidenav.toggle()" class="mr-2 lg:hidden">
          <mat-icon>menu</mat-icon>
        </button>
        <span class="flex-1"></span>
        <div class="flex items-center gap-2">
          @if (entities().length > 0) {
            <mat-form-field appearance="fill" class="w-48 text-sm" subscriptSizing="dynamic">
              <mat-label>Entity</mat-label>
              <mat-select
                [value]="selectedEntityIds()"
                (selectionChange)="onEntityChange($event.value)"
                multiple
              >
                <mat-select-trigger> {{ getEntityName(selectedEntityIds()) }} </mat-select-trigger>
                @for (entity of entities(); track entity.id) {
                  <mat-option [value]="entity.id">{{ entity.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <app-notification-center></app-notification-center>
          <button mat-icon-button (click)="themeService.toggleTheme()">
            <mat-icon>{{ themeService.isDarkMode() ? "light_mode" : "dark_mode" }}</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="userMenu">
            <mat-icon>account_circle</mat-icon>
          </button>
          <mat-menu #userMenu="matMenu">
            <div class="px-4 py-2 border-b border-[var(--mat-sys-outline-variant)]">
              <div class="text-sm font-medium text-[var(--mat-sys-on-surface)]">
                {{ (currentUser$ | async)?.name }}
              </div>
              <div class="text-xs text-[var(--mat-sys-on-surface-variant)]">
                {{ (currentUser$ | async)?.email }}
              </div>
            </div>
            <button mat-menu-item (click)="openUserProfile()">
              <mat-icon>person</mat-icon>
              <span>Manage Account</span>
            </button>
            <button mat-menu-item (click)="logout()">
              <mat-icon>logout</mat-icon>
              <span>Logout</span>
            </button>
          </mat-menu>
        </div>
      </mat-toolbar>
    }

    <main class="flex-1 min-h-0 overflow-auto flex flex-col">
      @if (!clerkService.loaded() || (clerkService.isAuthenticated() && !isAuthenticated())) {
        <!-- Authentication Check Loading State -->
        <div
          class="fixed inset-0 z-[999] flex items-center justify-center bg-[var(--mat-sys-background)]"
        >
          <div class="flex flex-col items-center gap-4">
            <mat-spinner diameter="48"></mat-spinner>
            <p class="text-[var(--mat-sys-on-surface-variant)] text-sm font-medium">
              Verifying account...
            </p>
          </div>
        </div>
      }
      @if (clerkService.loaded() && (isAuthenticated() || !clerkService.isAuthenticated())) {
        <router-outlet></router-outlet>
      }
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
<app-chat-widget />
